import React, { FC } from 'react';
import styles from './login.module.scss';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/ui/button';
import Heading from '../../components/ui/heading';
import { CustomPasswordInput } from '../../components/ui/fields/form/custom-password-input';
import { Col, Form, notification, Row } from 'antd';
import { CustomInput } from '../../components/ui/fields/form/custom-input';
import { StrokedButton } from '../../components/ui/stroked-button';
import { useLogin, useNavigation } from '@refinedev/core';
import { getFilteredResourcesByUser } from '../../utils/resource-filter';
import { useLocalizedResources } from '../../hooks/useLocalizedResources';

export const Login: FC = () => {
    const [form] = Form.useForm();
    const { mutate: login, isLoading } = useLogin();
    const { t } = useTranslation();
    const { replace } = useNavigation();

    const localizedResources = useLocalizedResources();

    const onSubmit = (values: { username: string; password: string }) => {
        try {
            login(
                {
                    username: values.username,
                    password: values.password,
                },
                {
                    onSuccess: () => {
                        const user = JSON.parse(localStorage.getItem('user')!);

                        const filtered = getFilteredResourcesByUser(
                            user,
                            localizedResources
                        );

                        const firstResource = filtered?.[0]?.name;

                        if (firstResource) {
                            replace(`/${firstResource}`);
                        } else {
                            replace('/');
                        }
                    },
                    onError: error => {
                        notification.error({
                            message: t('notifications.login_error'),
                            description: error?.message,
                        });
                    },
                }
            );
        } catch (error) {
            console.error('Login error:', error);
        }
    };

    return (
        <Row gutter={[20, 20]}>
            <Col xs={24}>
                <div className={styles.pageLogin}>
                    <div className={styles.pageSection}>
                        <Heading level={1}>
                            {t('pages.login.password_authorization')}
                        </Heading>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onSubmit}
                            disabled={isLoading}
                            className={styles.form}
                        >
                            <CustomInput
                                name="username"
                                label={t('pages.login.username')}
                                required
                            />
                            <CustomPasswordInput
                                name="password"
                                label={t('pages.login.password')}
                                required
                            />
                            <Button
                                className={styles.btnSubmit}
                                htmlType="submit"
                                loading={isLoading}
                                disabled={isLoading}
                            >
                                {t('pages.login.signin')}
                            </Button>
                        </Form>
                    </div>

                    <div className={styles.pageSection}>
                        <Heading level={2}>
                            {t('pages.login.other_methods_of_authorization')}
                        </Heading>
                        <div className={styles.keyAuthorization}>
                            <StrokedButton
                                href={'#'}
                                label={t('pages.login.file_key')}
                            />
                            <StrokedButton
                                href={'#'}
                                label={t('pages.login.hardware_key')}
                            />
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    );
};
